/**
 * SyncProvider — invisible provider for cross-tab sync.
 * Renders nothing. Theme sync is handled by the theme module's own
 * cross-tab listener (loaded at import time), so we only need to wire
 * the language sync hook here.
 */
import { useLanguageSync } from "@/shared/hooks/useLanguageSync";

function SyncEngine() {
  useLanguageSync();
  return null;
}

/**
 * SyncProvider — wraps SyncEngine.
 * Import and render once in main.tsx before the router.
 */
export function SyncProvider() {
  return <SyncEngine />;
}